import React from 'react';
import styled from 'styled-components';
import { Collapse } from 'antd';
/**
 * * 접이식 박스
 * - antd 컴포넌트 활용
 */
interface InterfaceProps {
  activeKey?: string[] | string | number[] | number;
  defaultActiveKey?: string[] | string | number[] | number;
  bordered?: boolean;
  collapsible?: 'header' | 'icon' | 'disabled';
  header?: string | React.ReactElement;
  key?: string | number;
  showArrow?: boolean;
  onChange?: () => void;
  children?: any;
}

const CollapseBox = ({ children, defaultActiveKey }) => {
  return (
    <CollapseStyle defaultActiveKey={defaultActiveKey}>
      {children}
    </CollapseStyle>
  );
};

export default CollapseBox;

const CollapseStyle = styled(Collapse)<InterfaceProps>``;
